var map = {
	"./1.jpg": 483,
	"./2.jpg": 772,
	"./3.jpg": 2577,
	"./4.jpg": 7346,
	"./5.png": 3743,
	"./6.png": 9252,
	"./7.png": 2285,
	"./8.png": 9338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9195;